if($('.id--7').length){
    $('.content-inner').prepend($('footer#footer .lostPassword'));
    $('input[type="email"]').attr('placeholder', 'Váš e-mail');
    $('input[value="Odeslat"]').attr('value', 'Obnovit heslo');
}

if($('.breadcrumbs span#navigation-1').length){
    if($('.breadcrumbs span#navigation-1 [itemprop="name"]').text().trim() === 'Klientské centrum'){
        $('body').addClass('klientCenterScript');
        $('.client-center-box ul li a').each(function(){
            if($(this).text().trim() === 'Moje osobní údaje'){
                $(this).text('Nastavení účtu');
                $(this).closest('li').addClass('mySettings')
            }
            if($(this).text().trim().split('(')[0].trim() === 'Moje objednávky'){
                $(this).closest('li').addClass('myOrders');
                $(this).text('Moje objednávky');
            }
            if($(this).text().trim().split('(')[0].trim() === 'Moje daňové doklady'){
                $(this).text('Moje faktury');
                $(this).closest('li').addClass('myInvoices')
            }
        })
        $('.client-center-box ul').append('<li class="mainPage '+$('.client-center-box ul li a[href="/klient/"]').closest('li').attr('class')+'"><a href="/klient/">Hlavní stránka</a></li>')
    }
}

if($('.id--12, .id--18').length){
    $('table.table:not(.table-order-details) tr').each(function(){
        $(this).append('<td class="detail"><a href="'+$(this).find('td').first().find('a').attr('href')+'">Detail</a></td>')
        $(this).find('td').each(function(index){
            $(this).addClass('class-' + (index + 1));
        });
        
    })
}

if($('.id--43').length){
    $('table.table tr').each(function(){
        $(this).append('<td></td><td class="detail"><a href="'+$(this).find('td').first().find('a').attr('href')+'">Faktura</a></td>')
        $(this).find('td').each(function(index){
            $(this).addClass('class-' + (index + 1));
        });
        
    })
}

if ($('.id--18 .table-order-details').length > 0) {
    $('body').addClass('customOrderListDetail');

    const $content = $('.content-inner');
    const $table = $('.table-order-details');

    const orderTitle = $content.children('h2').first().text().trim();
    const orderNumber = orderTitle.split('č.')[1]?.trim() || '';
    const orderDateText = $content.children('div').first().find('p').first().text().replace('Datum objednávky:', '').trim();
    const reorderUrl = $('a[href^="/action/Cart/addItemsFromOrderForLoggedCustomer/?code="]').attr('href') || '#';

    let productCodes = [];

    $table.find('tbody > tr').each(function () {
        const $product = $(this).find('.p-name__itemLink');
        if (!$product.length) return;

        const code = String($product.closest('.p-name').find('.p-name__code').text().trim() || '');
        if (code) productCodes.push(code);
    });

    productCodes = [...new Set(productCodes)];

    function renderOrder(images = {}) {
        let productsHtml = '';

        $table.find('tbody > tr').each(function () {
            const $row = $(this);
            const $product = $row.find('.p-name__itemLink');
            if (!$product.length) return;

            const name = $product.text().trim();
            const url = $product.attr('href');
            const amountText = $row.find('td:nth-child(2) strong').text().trim();
            const amount = parseFloat(amountText.replace(',', '.')) || 0;

            const code = String(
                $product.closest('.p-name').find('.p-name__code').text().trim() || ''
            );

            const image = (
                code &&
                images[code] &&
                Array.isArray(images[code]) &&
                images[code].length
            ) ? String(images[code][0]) : '';

            productsHtml += `
                <div class="customOrderProduct">
                    <div class="customOrderProduct__amount">${amount}x</div>

                    <div class="customOrderProduct__image">
                        <a href="${url}" class="customOrderProduct__imageLink">
                            ${image ? `<img src="${image}" alt="${name}" loading="lazy">` : ''}
                        </a>
                    </div>

                    <div class="customOrderProduct__content">
                        <a href="${url}" class="customOrderProduct__name">${name}</a>
                        ${code ? `<div class="customOrderProduct__code">${code}</div>` : ''}
                    </div>
                </div>
            `;
        });

        const summaryRows = [];

        $table.find('tbody > tr').each(function () {
            const $row = $(this);
            const $name = $row.find('.p-name__itemName');
            if (!$name.length) return;

            let price = $row.find('td').last().find('strong').text().trim();
            if (price === '0 Kč') price = '<span class="customOrderFree">Zdarma</span>';

            summaryRows.push({
                name: $name.text().trim(),
                price: price
            });
        });

        const shipping = summaryRows[0] || {};
        const payment = summaryRows[1] || {};

        let totalWithVat = '';

        $table.find('.list-summary dt').each(function () {
            const label = $(this).text().trim();
            const value = $(this).next('dd').text().trim();

            if (label.includes('Cena celkem včetně DPH')) {
                totalWithVat = value;
            }
        });

        const $addressRow = $content.find('h2:contains("Údaje o zákazníkovi")').next('.row');
        const $billing = $addressRow.find('.col-md-6').eq(0).clone();
        const $shippingAddress = $addressRow.find('.col-md-6').eq(1).clone();

        $billing.find('h4').remove();
        $shippingAddress.find('h4').remove();

        const customOrdersDetail = `
            <div class="customOrdersList">
                <div class="ordersTop">
                    <div class="ordersTop__left">
                        <h2>Objednávka č. <span>${orderNumber}</span></h2>
                        <span class="ordersTop__date">${orderDateText}</span>
                    </div>

                    <div class="ordersTop__right">
                        <a href="${reorderUrl}" class="btn btn-primary">Znovu nakoupit</a>
                    </div>
                </div>

                <div class="ordersBottom">
                    <div class="ordersBottom__left">
                        <div class="customOrderBox customOrderProducts">
                            <h4>Obsah objednávky</h4>
                            <div class="customOrderProducts__list">${productsHtml}</div>
                        </div>
                    </div>

                    <div class="ordersBottom__right">
                        <div class="customOrderBox customOrderSummary">
                            <h5>Shrnutí objednávky</h5>

                            <div class="customOrderSummary__main">
                                ${shipping.name ? `
                                    <div class="customOrderSummary__row">
                                        <span>Zvolená doprava</span>
                                        <strong>${shipping.name}</strong>
                                    </div>
                                ` : ''}

                                ${payment.name ? `
                                    <div class="customOrderSummary__row">
                                        <span>Zvolená platba</span>
                                        <strong>${payment.name}</strong>
                                    </div>
                                ` : ''}

                                <div class="customOrderSummary__row customOrderSummary__total">
                                    <span>Celkem</span>
                                    <strong>${totalWithVat}</strong>
                                </div>
                            </div>

                            <div class="customOrderSummary__address">
                                <h5>Fakturační adresa</h5>
                                <div class="customOrderAddress">${$billing.html()}</div>
                            </div>

                            <div class="customOrderSummary__address">
                                <h5>Dodací adresa</h5>
                                <div class="customOrderAddress">${$shippingAddress.html()}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;

        $content.prepend(customOrdersDetail);
        $content.children().not('.customOrdersList').hide();
    }

    $.ajax({
        url: 'https://crm.misimame.com/www/api/product-shoptet-images',
        type: 'GET',
        dataType: 'json',
        data: {
            productCode: productCodes.join(','),
            api_key: '50wsrVKxv9I2GsmAD6uy2s3Mwit3aK'
        },
        success: function (images) {
            renderOrder(images);
        },
        error: function () {
            renderOrder({});
        }
    });
}